import { STAGE_CASE_ACTIONS } from "constants";

export function fetchStageCase(
    type,
    stage,
    stageId,
    page,
    pageSize,
    filters = null,
    documentFilter
) {
    return {
        type: STAGE_CASE_ACTIONS.FETCH_STAGE_CASE,
        payload: {
            type,
            stage,
            stageId,
            page,
            pageSize,
            filters,
            documentFilter
        }
    };
}

export function fetchedStageCase(type, stage, page, cases, count, filters) {
    return {
        type: STAGE_CASE_ACTIONS.FETCHED_STAGE_CASE,
        payload: {
            type,
            stage,
            page,
            cases,
            count,
            filters
        }
    };
}

export function failedFetchStageCase(type, stage, error, filters) {
    return {
        type: STAGE_CASE_ACTIONS.FAILED_FETCH_STAGE_CASE,
        payload: {
            type,
            stage,
            error,
            filters
        }
    };
}

export function fetchedStageCaseCount(type, stage, count) {
    return {
        type: STAGE_CASE_ACTIONS.FETCHED_STAGE_CASE_COUNT,
        payload: {
            type,
            stage,
            count
        }
    };
}

export function resetStageCase(type, stage) {
    return {
        type: STAGE_CASE_ACTIONS.RESET_STAGE_CASE,
        payload: {
            type,
            stage
        }
    };
}

export function resetInboxStage(type, stage) {
    return {
        type: STAGE_CASE_ACTIONS.RESET_INBOX_STAGE,
        payload: {
            type,
            stage
        }
    };
}
